import { PipeTransformPipe } from './../../shared/pipe/pipe-transform.pipe';
import { SubscriptionPackagesModule } from './../subscription-packages/subscription-packages.module';
import { PaymentFlowModule } from './../payment-flow/payment-flow.module';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { SharedModule } from "../../shared/shared.module";

import { HomeComponent } from './components/home.component';
import { VerifyComponent } from './components/verify.component';
import { homeRouting, homeRoutingProviders } from './home.routes';
import { AppLoginModule } from './../app-login/app-login.module';
// import { RegistrationModule } from './../registration/registration.module';


@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    SharedModule,
    homeRouting,
    PaymentFlowModule,
    AppLoginModule,
    SubscriptionPackagesModule
    // RegistrationModule
  ],
  declarations: [
    HomeComponent,
    VerifyComponent,
  ],
  providers: [ homeRoutingProviders, PipeTransformPipe ],

})
export class HomeModule { }



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/home/home.module.ts